import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import cart from './modules/cart'
import modal from './modules/modal'
import resellerModal from './modules/reseller-modal'
import auth from './modules/auth'
import persistent from './modules/persistent'
import search from './modules/search'
import paymentMethods from './modules/payment-methods'
import messages from './modules/msg'
import {debugLog,msg} from "vue-src/utils";
import env from "vue-src/utils/constants"
import {tokenInspected} from "vue-src/IxPlugin/api"

function initialized(response){
  debugLog('INITIALIZED!', response)
  return Promise.resolve(response)
}

function oopsieDaisy(response){
  msg.danger('Oh no! something went wrong!')
  return Promise.reject(response)
}

const persistedOpts = {paths: ['persistent']}

const debug = env.NODE_ENV !== 'production'
//console.log(Vue)
Vue.use(Vuex)
export default new Vuex.Store({
  strict: debug,
  modules: {
    cart,
    modal,
    resellerModal,
    auth,
    persistent,
    search,
    msg:messages,
    paymentMethods
  },
  state: {
    initialization: tokenInspected(),
    promise_401: Promise.resolve()
  },
  getters:{
    getInit(state){
      return state.initialization
    },
  },
  mutations: {
    setInitial(state, payload) {
      state.initialization = payload
    },
    setPromise401(state, payload){
      state.promise_401 = payload
    },
  },
  actions: {
    async init({dispatch, commit}) {
      await tokenInspected()

      let initCart = dispatch('initCart'),
        initAuth = dispatch('initAuth'),
        initPersistent = dispatch('initPersistent')
      let payload = Promise.all([
        initCart,
        initAuth,
        initPersistent,
      ]).then(initialized).catch(oopsieDaisy)
      commit('setInitial', payload)
      return payload
    },
  },
  plugins: [createPersistedState(persistedOpts)],
})



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/index.js